import React from "react";
import Lottie from "lottie-react";
import Confetti from "../icons/1103-confetti-lineal.json";
import PhoneNumberService from "../utils/phone-number-services";

import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

interface Props {
	handleReset: () => void;
	sentFailedPhones: string[];
}

const SuccessBanner = ({ handleReset, sentFailedPhones }: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}>
			<Lottie animationData={Confetti} style={{ width: 200, height: 200 }} />
			<Typography variant='h4'>Woohoo, your campaign has been sent!</Typography>
			{Boolean(sentFailedPhones.length) && (
				<Box sx={{ my: 2 }}>
					<Alert severity='warning'>
						<AlertTitle>{`There are ${sentFailedPhones.length} invalid phone numbers that we could not send.`}</AlertTitle>
						<ul>
							{sentFailedPhones.map((phone) => (
								<li>
									<Typography variant='body2'>
										{PhoneNumberService.formatPhoneNumber(phone)}
									</Typography>
								</li>
							))}
						</ul>
					</Alert>
				</Box>
			)}
			<Button variant='contained' onClick={handleReset} sx={{ mt: 2 }}>
				New campaign
			</Button>
		</Box>
	);
};

export default SuccessBanner;
